module.exports = __webpack_public_path__ + "static/media/android-icon-192x192.8fb6c26d.png";